var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEtcServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 204,
    viewBox: "0 0 191 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2235_130)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2235_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.009 157.904L119.444 178.988L58.3432 202.654L17.0359 178.989L82.009 157.904Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5531 65.5283C48.8118 65.5283 36.8775 74.9852 33.7367 88.3627L20.4775 144.837C18.12 154.878 25.7396 164.494 36.054 164.494H98.4414L105.792 182.136L155.609 164.432C165.393 163.58 172.248 154.033 169.632 144.33L153.176 83.2817C150.352 72.8066 140.852 65.5283 130.003 65.5283H62.5531Z",
    fill: "#1F2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1777 34.7815C63.7189 25.1042 71.2124 16.3965 80.999 16.3965H109.947C119.727 16.3965 127.219 25.0929 125.771 34.765L121.193 65.3479C120.314 71.2238 115.267 75.5715 109.326 75.5715H81.6533C75.7166 75.5715 70.6722 71.2305 69.7873 65.3602L65.1777 34.7815Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.009 152.74L100.726 163.282L108.374 176.972L58.3432 197.49L17.0359 173.824L82.009 152.74Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.193 179.964L100.664 163.618L73.9766 166.161C72.8465 166.268 72.2192 167.522 72.8107 168.491C73.8204 170.145 75.6423 171.129 77.5794 171.065L89.1547 170.682L88.1862 172.016C87.3285 173.197 86.1904 174.147 84.8744 174.778L68.7408 182.525C66.8009 183.457 66.3149 185.999 67.7745 187.581L69.9888 189.98C73.3143 193.582 78.1079 195.461 82.9958 195.078L88.5385 194.644C92.3741 194.343 96.031 192.898 99.0349 190.494L112.193 179.964Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3692 63.538C86.4684 63.4286 87.4481 64.2309 87.5575 65.33L87.992 69.6934C88.1015 70.7925 87.2992 71.7722 86.2001 71.8817C85.1009 71.9911 84.1212 71.1888 84.0117 70.0897L83.5772 65.7263C83.4678 64.6272 84.2701 63.6475 85.3692 63.538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.994 63.538C104.895 63.4286 103.915 64.2309 103.806 65.33L103.371 69.6934C103.262 70.7925 104.064 71.7722 105.163 71.8817C106.262 71.9911 107.242 71.1888 107.352 70.0897L107.786 65.7263C107.895 64.6272 107.093 63.6475 105.994 63.538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8061 78.6992C54.5015 71.11 34.6574 67.7753 25.8984 67.0566C35.5477 77.4056 48.5856 108.452 53.8984 122.682L87.4984 127.857L63.8061 78.6992Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6992 74.9595C31.3255 80.8281 34.7632 101.713 40.3495 112.069L46.7952 128.035L85.8992 131.056L61.4055 80.5695C46.7952 74.5283 23.8771 73.2335 10.6992 74.9595Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1424 121.702L58.9318 125.352C56.5159 129.34 52.1777 131.945 47.6155 130.98C45.4807 130.528 43.1882 129.816 41.1798 128.694C37.6424 126.717 35.4799 121.748 34.8164 120.16L28.3306 102.789C27.5788 100.776 28.6928 98.6662 30.7838 99.1638C30.9268 99.1979 31.0726 99.236 31.221 99.2785C34.3994 100.189 39.3937 107.678 40.4344 111.284L49.5647 100.052C51.2861 97.9341 54.5761 98.1241 56.0423 100.426L60.9902 108.194C63.6063 112.301 63.6653 117.537 61.1424 121.702Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9994 16.3955C71.2128 16.3955 63.7194 25.1032 65.1782 34.7805L69.5404 63.7182L106.604 53.0352L122.096 59.3187L125.771 34.764C127.219 25.0919 119.728 16.3955 109.948 16.3955H80.9994Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2235_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.6,
    height: 203.2,
    fill: "white",
    transform: "translate(0.699219 0.65625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2235_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.6,
    height: 203.2,
    fill: "white",
    transform: "translate(0.699219 0.65625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEtcServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcEtcServiceBodyMobile.284050c59d24ae271b3c9859b3b1e425.svg";
export { ForwardRef as ReactComponent };